import React from 'react';
import { connect } from 'react-redux';
// import { isEmail, isEmpty } from 'validator';

import './contact.css';
import Render from './render';
// import Actions from '../../actions';
import { trackView } from '../../services/analytics';
import { TAPIRequestCanceller } from '../../services/api';
import { CONTACT, RESET_CONTACT_MESSAGES } from '../../constants/actions';

const DEFAULT_FORM_VALUES = {
  first_name: '',
  last_name: '',
  email: '',
  question: ''
};

class Contact extends React.Component<any> {
  request: TAPIRequestCanceller;

  state = {
    form: DEFAULT_FORM_VALUES,
    error: null
  };

  // validate = (): boolean => {
  //   const form = this.state.form;
  //   const empty = Object.values(form).every(isEmpty);
  //   const validEmail = isEmail(form.email);
  //   return !empty && validEmail;
  // };

  // change = (e) => {
  //   if (this.state.error) {
  //     this.setState(() => ({ error: null }));
  //   }
  //
  //   const target = e.target;
  //   this.setState((s: any) => ({
  //     form: {
  //       ...s.form,
  //       [target.name]: target.value
  //     }
  //   }));
  // };

  // submit = (e) => {
  //   e.preventDefault();
  //   if (!this.validate()) {
  //     this.setState(() => ({
  //       error: 'Form is not valid.'
  //     }));
  //     return;
  //   }
  //   this.request = Actions.post(this.props.dispatch, CONTACT, { ...this.state.form });
  //   this.setState(() => ({ form: DEFAULT_FORM_VALUES }));
  // };

  componentDidMount() {
    trackView(this.props.location.pathname);

    if (this.props.submissionSuccess || this.props.submissionError) {
      this.props.dispatch({ type: RESET_CONTACT_MESSAGES });
    }
  }

  componentWillUnmount() {
    if (this.request) {
      this.request.cancel('Contact unmounted');
    }
  }

  render() {
    return Render.call(this, this.props, this.state);
  }
}

const state = ({ contactForm: { error, success } }) => ({
  submissionError: error,
  submissionSuccess: success
});

export default connect(state)(Contact);



// WEBPACK FOOTER //
// ./src/containers/Contact/index.tsx